import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import HomePage from "./component/Hompage";
import Signup from "./pages/signup/Signup";
import Getotp from "./component/Signup/Getotp";
import Emailotp from "./component/Signup/Emailotp";
import SignUpFinish from "./component/Signup/SignUpFinish";

import Layout from "./component/Layout/Layout";
import Dashboard from "./pages/vendor-admin/dashboard/dashboard";
import Services from "./pages/vendor-admin/Services";
import ServicesDetails from "./pages/vendor-admin/ServicesDetails";
import Offers from "./pages/vendor-admin/Offers";
import Offerdetails from "./pages/vendor-admin/Offerdetails";
import Financials from "./pages/vendor-admin/Financials";
import FinancialDetails from "./pages/vendor-admin/FinancialDetails";
import Reviews from "./pages/vendor-admin/Reviews";
import Complaints from "./pages/vendor-admin/complaints/Complaints";
import Login from "./pages/login/Login";
import BranchListing from "./pages/vendor-admin/branch/BranchListing";
import AddEditBranches from "./pages/vendor-admin/branch/AddEditBranches";
import StaffListing from "./pages/vendor-admin/staff/StaffListing";
import AddEditStaff from "./pages/vendor-admin/staff/AddEditStaff";
import Coupon from "./pages/vendor-admin/coupon/CouponListing";

import ProtectedRoute from "./component/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import { Provider } from "react-redux";
import { store } from "./store";
import OrderLisitng from "./pages/vendor-admin/orders/OrderLisitng";
import OrderDetailPage from "./pages/vendor-admin/orders/OrderDetailPage";
import CompanyProfile from "./pages/vendor-admin/company-profile/CompanyProfile";
import ChangePassword from "./pages/vendor-admin/company-profile/ChangePassword";
import { MovableProvider, useMovable } from "./context/MovableContext";
import { useLiveLocation } from "./hooks/useLiveLocation";
import AddEditCoupon from "./pages/vendor-admin/coupon/AddEditCoupon";
import CustomerListing from "./pages/vendor-admin/customers/CustomerListing";
import CustomerDetails from "./pages/vendor-admin/customers/CustomerDetails";
import ComplaintsDetails from "./pages/vendor-admin/complaints/ComplaintsDetails";
import Privacy from "./component/legal/Privacy";
import TermsCondition from "./component/legal/TermsCondition";
import AccountDelete from "./component/legal/AccountDelete";



const protectedRoutes = [
  { path: "dashboard", element: <Dashboard /> },
  { path: "Staff", element: <StaffListing /> },
  { path: "Staffdetails", element: <AddEditStaff /> },
  { path: "Staffdetails/:staffId", element: <AddEditStaff /> },
  { path: "branches", element: <BranchListing /> },
  { path: "branch-details", element: <AddEditBranches /> },
  { path: "branch-details/:shopId", element: <AddEditBranches /> },
  { path: "services", element: <Services /> },
  { path: "services-details", element: <ServicesDetails /> },
  { path: "offers", element: <Offers /> },
  { path: "offerdetails", element: <Offerdetails /> },
  { path: "financials", element: <Financials /> },
  { path: "financialDetails", element: <FinancialDetails /> },
  { path: "reviews", element: <Reviews /> },
  { path: "complaints", element: <Complaints /> },
  { path: "complaints-details/:id", element: <ComplaintsDetails /> },
  { path: "orders", element: <OrderLisitng /> },
  { path: "order-detail/:orderId", element: <OrderDetailPage /> },
  { path: "company-profile", element: <CompanyProfile /> },
  { path: "change-password", element: <ChangePassword /> },
  { path: "coupon", element: <Coupon /> },
  { path: "coupon-details", element: <AddEditCoupon /> },
  { path: "coupon-details/:couponId", element: <AddEditCoupon /> },
  { path: "customers", element: <CustomerListing /> },
  { path: "customers-details/:customerId", element: <CustomerDetails /> }
];

function App() {

  const movable = useMovable()
  const { locationEnable, shopId } = movable

  useLiveLocation(locationEnable, shopId)

  return (
    <AuthProvider>
      <Provider store={store} >
        <BrowserRouter>
          <div className="App">
            <ToastContainer
              position="bottom-left"
              autoClose={2000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />

            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/getotp" element={<Getotp />} />
              <Route path="/emailotp" element={<Emailotp />} />
              <Route path="/signupfinish" element={<SignUpFinish />} />

              {/* Protected Routes */}
              <Route >
                <Route path="/vendor-admin" element={<Layout />}>
                  {protectedRoutes.map(({ path, element }) => (
                    <Route key={path} path={path} element={element} />
                  ))}
                </Route>
              </Route>

              {/* Legal pages */}
              <Route path="/privacy-policy" element={<Privacy />} />
              <Route path="/terms-condition" element={<TermsCondition />} />
              <Route path="/account-delete" element={<AccountDelete />} />
        
              {/* Fallback */}
              <Route path="*" element={<div>404 - Page Not Found</div>} />
            </Routes>
          </div>
        </BrowserRouter>
      </Provider>
    </AuthProvider>
  );
}


export default App;
